import React, { createContext, useContext, useState, ReactNode } from 'react';
import { IFiltroListaDemandas } from '../types';

interface SidebarFiltrosContextType {
  isSidebarFiltrosOpen: boolean;
  setSidebarFiltrosOpen: (open: boolean) => void;
  toggleSidebarFiltros: () => void;
  filtros: IFiltroListaDemandas;
  setFiltros: (filtros: IFiltroListaDemandas) => void;
  resetFiltros: () => void;
}

const SidebarFiltrosContext = createContext<SidebarFiltrosContextType | undefined>(undefined);

interface SidebarFiltrosProviderProps {
  children: ReactNode;
}

export const SidebarFiltrosProvider: React.FC<SidebarFiltrosProviderProps> = ({ children }) => {
  const [isSidebarFiltrosOpen, setSidebarFiltrosOpen] = useState(false);
  const [filtros, setFiltros] = useState<IFiltroListaDemandas>({});

  const toggleSidebarFiltros = () => {
    setSidebarFiltrosOpen(!isSidebarFiltrosOpen);
  };

  const resetFiltros = () => {
    setFiltros({});
  };

  return (
    <SidebarFiltrosContext.Provider
      value={{
        isSidebarFiltrosOpen,
        setSidebarFiltrosOpen,
        toggleSidebarFiltros,
        filtros,
        setFiltros,
        resetFiltros,
      }}
    >
      {children}
    </SidebarFiltrosContext.Provider>
  );
};

export const useSidebarFiltros = () => {
  const context = useContext(SidebarFiltrosContext);
  if (context === undefined) {
    throw new Error('useSidebarFiltros must be used within a SidebarFiltrosProvider');
  }
  return context;
};
